<template>
  <div class="QuotationEdit" data-title="发布报价">
    <div class="quotation-type">
      <van-tabs
        v-if="quoteType"
        v-model="quoteType"
        :offset-top="0"
        sticky
        type="card"
        color="#1e67c7"
        @click="changeQuoteType"
      >
        <van-tab  v-for="quoteType in quoteTypes" :key="quoteType.value" :title="quoteType.text" :name="quoteType.value"></van-tab>
      </van-tabs>
    </div>
    <QuotationEditComponent
      from="quotation"
      :quoteType="quoteType"
      :showActionButton="true"
      @publish="quotesAdd"
      @back="back"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import storage from '@/uitls/cacheUtil';
import QuotationEditComponent from '@/components/QuotationEditComponent.vue';
import {
  sendRequest, quotesAdd, quotesCrabAdd, quoteTypeLast,
} from '@/network/NetworkAccessor';
import { QUOTE_SECTION } from '@/uitls/const';


export default Vue.extend({
  name: 'QuotationEdit',
  components: {
    QuotationEditComponent,
  },
  data() {
    return {
      // 普货、普挑、精挑、挑膏
      sectionMapping: QUOTE_SECTION,
      quoteTypes: [],
      quoteType: '',
      lastData: {
      },
      formValues: {
      },
    };
  },
  props: {
    isMarket: {
      type: Boolean,
      default: false,
    },
  },
  computed: {

  },
  watch: {
  },
  methods: {
    changeQuoteType(val) {
      this.quoteType = val;
      const { origin, pathname } = window.location;
      window.history.replaceState({}, null, `${origin}${pathname}?quoteType=${val}`);
    },
    // 上次报价类型
    getLastQuoteType() {
      return sendRequest(quoteTypeLast).then((quoteType) => {
        this.quoteType = `${quoteType || this.firstQuoteType || '1'}`;
      }).catch((e) => {
        console.log(e);
      });
    },
    // 获取上次报价信息
    getLastData() {
      // sendRequest(quoteLast, { quoteType: this.quoteType }).then((res) => {
      //   if (!res) {
      //     return;
      //   }
      //   const list = res || [];
      //   const { quotes, ...values } = list.length > 0 ? list[0] : {};
      //   this.lastData = {
      //     formValues: {
      //       ...this.formValues,
      //       ...values,
      //     },
      //     quoteValues: JSON.parse(quotes),
      //   };
      // }).catch((e) => {
      //   console.error(e);
      // }).then(() => {
      //   this.loading = false;
      // });
    },
    quotesAdd(params) {
      // console.log('publish------', params);
      if (!params || !params.length) {
        this.$dialog.alert({
          message: '请至少填写一条有效报价',
        });
        return;
      }
      let pros = [];
      // 螃蟹报价走单独接口
      if (this.quoteType == '2') {
        const pro = sendRequest(quotesCrabAdd, params).catch((e) => {
          console.error(e);
          // this.$dialog.alert({
          //   message: '发布报价失败',
          // });
          throw new Error('发布螃蟹报价失败');
        });
        pros = [pro];
      } else {
        pros = params.map(item => sendRequest(quotesAdd, item).catch((e) => {
          console.error(e);
          // this.$dialog.alert({
          //   message: '发布报价失败',
          // });
          throw new Error(`发布${this.sectionMapping[item.section] || ''}报价失败`);
        }));
      }
      Promise.all(pros).then(() => {
        this.$router.push({ name: 'QuotationEditSuccess', params: { quoteType: `${this.quoteType}` } });
      }).catch((e) => {
        console.error(e);
        this.$dialog.alert({
          message: e.message,
        });
      });
    },
    back() {
      this.$router.push({ name: 'Home' });
    },
  },
  created() {
    // 可报价的品类
    const quoteTypes = (storage.local.get('M_L') || []).filter(item => item.route === 'QuotationEdit');
    this.quoteTypes = quoteTypes.map((item) => {
      const [, value] = item.code.split('_');
      return {
        value,
        text: item.name,
      };
    });

    this.quoteType = this.$route.query.quoteType || this.firstQuoteType || '';
    console.log('上次报价类型 1: ', this.quoteType);
    // 上次报价信息
    this.loading = true;
    const pros = [];
    if (!this.quoteType) {
      pros.push(this.getLastQuoteType());
    }
  },
});
</script>
<style scoped>
.QuotationEdit {
  min-height: 100vh;
  background-color: #ffffff;
  padding-bottom: 20px;
}
.QuotationEdit .select-palceholder {
  color: #a7a9af!important;
}
.QuotationEdit .border-bottom {
  /* border-bottom: 1px solid #1e67c7; */

}
.basic-select,.basic-textarea,.basic-input {
  width: 100%;
  color: #000000;
  font-size: 18px;
}
.form-item {

}
.form-item-label {
  width: 95px;
  text-align: right;
}
.form-item-label-text.required::before {
  content: '*';
  color: red;
}
.form-item-select,.form-item-textarea,.form-item-input {
  width: 100%;
}

.QuotationEdit .table-quotation {
  margin-top: 15px;
  width: 100%;
  border-spacing: 0;
  border-radius: 4px;
  border: 1px solid #1e67c7;
  /* border-top: 1px solid #a7a9af;
  border-left: 1px solid #a7a9af;
  border-right: 1px solid #a7a9af; */
}
.table-quotation th {
  background-color: #dde1e7;
  /* color: #1e67c7; */
  padding: 6px 0;
  border-bottom: 1px solid #1e67c7;
}
.table-quotation td {
  padding: 6px 2px;
  border-bottom: 1px solid #1e67c7;
}
.table-quotation >>> .van-field__right-icon {
  padding: 2px;
  padding-right: 8px;
}
.table-quotation >>> .van-field__right-icon .van-icon {
  font-size: 18px;
}
.table-quotation .quote-item {
  /* max-width: ; */
}
.sort-box .sort-select,.sort-input {
  border: 0;
  appearance:none;
  text-align: center;
  opacity: 1!important;
  color: #000000!important;
}
</style>
